/*========================================================================================================================================================
  #                                                                 GLOBAL FUNCTIONS
==========================================================================================================================================================*/
const currentUrl = window.location.href;

function sayHello(){
  return console.log("hello")
}
function isProductPage(){
  return currentUrl.includes("/products/")
}
function isWishlistPage(){
  return currentUrl.includes("/wishlist")
}
function isCollectionPage(){
  return currentUrl.includes("/collections/")
}
function isSearchPage(){
  return currentUrl.includes("/search")
}
function isCartPage(){
  return currentUrl.includes("/cart")
}
function isContactPage(){
  return currentUrl.includes("/contacta")
}



// // --------- DO something every change of url, in case the collection filter is used. ---------
// function isCollectionPageFilterClicked(myCallback){
//   if(isCollectionPage()){
//     let previousUrl = "";
//     const observer = new MutationObserver(function (mutations) {
//       if (window.location.href !== previousUrl) {
//         previousUrl = window.location.href;
//         setTimeout(() => {
//           myCallback()
//         }, 200);
//       }
//     });
//     const myConfig = { subtree: true, childList: true };
//     observer.observe(document, myConfig);     
//   }
// }

// // --------- DO something  when in collection page more products are loaded ---------
// function doItWhenProductListGrows(callback) {
//     function handleChildCountChange(mutationsList, observer) {
//         for(let mutation of mutationsList) {
//             if (mutation.type === 'childList') {      
//                 let numberOfChildren = mutation.target.children.length;
//                 // console.log('Number of children changed to:', numberOfChildren);
//                 callback();
//             }
//         }
//     }
//     let targetNode = document.querySelector('.m-collection-products');
//     let config = { childList: true };
//     let observer = new MutationObserver(handleChildCountChange);
//     if (targetNode) {
//         observer.observe(targetNode, config);
//     } 
// }
 
// // --------- DO something when the section has loaded, pass the section as param to the cb ---------
// function waitForSectionToBeLoaded(target, callback) {
//   const outerObserver = new MutationObserver((mutationsList, observer) => {
//     const targetElement = document.querySelector(target);
//     if (targetElement) {
//       observer.disconnect(); 
//       callback(targetElement);
//     }
//   });
//   outerObserver.observe(document.documentElement, { childList: true, subtree: true });
// }

// // --------- DO something when the section has loaded , 2 nested target, empty cb param---------
// function waitForSectionToBeLoaded2(parent, target, callback) {
//   const outerObserver = new MutationObserver((mutationsList, observer) => {
//     const parentElement = document.querySelector(parent);
//     const targetElement = parentElement.querySelector(target);
//     if (targetElement) {
//       observer.disconnect(); 
//       callback();
//     }
//   });
//   outerObserver.observe(document.documentElement, { childList: true, subtree: true }); 
// }

/*=======================================================================================
  #                                  PANGO ACCORDION
=======================================================================================*/
const dropdowns =  document.querySelectorAll('.p-dropdown')
dropdowns.forEach( dropdown  => {
  dropdown.addEventListener('click', () => {
    dropdown.classList.toggle('open');
  });
});
 
/*========================================================================================================================================================
  #                          PILOT CROSS-SELL CAROUSEL — autoplay cada 6 s
==========================================================================================================================================================*/
(function initPilotRoutineCarousel() {
  function bindCarousel(carousel) {
    if (carousel.dataset.pilotAutoplayBound === 'true') return;
    carousel.dataset.pilotAutoplayBound = 'true';

    var seconds = parseInt(carousel.dataset.pilotAutoplay || '6', 10);
    if (isNaN(seconds) || seconds < 4) seconds = 6;
    var delay = seconds * 1000;
    var timer = null;
    var paused = false;

    function step() {
      if (paused || !carousel.cells || carousel.cells.length <= 3) return;
      var group = carousel.groupCells || 1;
      var idx = carousel.selectedIndex;
      var maxIndex = carousel.cells.length - 1;
      if (idx + group <= maxIndex) carousel.next();
      else carousel.select(0);
    }

    function start() {
      clearInterval(timer);
      if (carousel.cells && carousel.cells.length > 3) {
        timer = setInterval(step, delay);
      }
    }

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    carousel.addEventListener('mouseenter', function () { paused = true; stop(); });
    carousel.addEventListener('mouseleave', function () { paused = false; start(); });
    start();
  }

  function initAll() {
    document.querySelectorAll('scroll-carousel.pilot-routine-pair__carousel').forEach(function (carousel) {
      if (typeof carousel.next === 'function' && carousel.cells && carousel.cells.length > 0) {
        bindCarousel(carousel);
      }
    });
  }

  function boot() {
    var attempts = 0;
    function tryInit() {
      initAll();
      attempts += 1;
      if (attempts < 12) setTimeout(tryInit, 500);
    }

    if (customElements.get('scroll-carousel')) {
      setTimeout(tryInit, 200);
    } else {
      customElements.whenDefined('scroll-carousel').then(function () {
        setTimeout(tryInit, 200);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initAll, 300);
  });
})();

/*========================================================================================================================================================
  #                          PANGO TABS — truncado "Leer más"
==========================================================================================================================================================*/
(function initPangoTabClamp() {
  function getClampMax(clamp) {
    var inner = clamp.querySelector('.pango-tab-clamp__inner');
    if (!inner) return 300;
    var styles = getComputedStyle(clamp);
    var raw = styles.getPropertyValue('--tab-clamp-max').trim();
    if (!raw) return 300;
    var probe = document.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = raw;
    probe.style.width = '1px';
    document.body.appendChild(probe);
    var height = probe.offsetHeight;
    document.body.removeChild(probe);
    return height || 300;
  }

  function measureClamp(clamp) {
    var inner = clamp.querySelector('.pango-tab-clamp__inner');
    var toggle = clamp.querySelector('.pango-tab-clamp__toggle');
    if (!inner || !toggle) return;

    if (clamp.classList.contains('is-expanded')) {
      clamp.classList.remove('is-clamp-short');
      return;
    }

    var parent = clamp.parentElement;
    var parentWasHidden = parent && parent.classList.contains('tab-content') && !parent.classList.contains('show-tab');
    var saved = {};

    if (parentWasHidden && parent) {
      saved.display = parent.style.display;
      saved.position = parent.style.position;
      saved.visibility = parent.style.visibility;
      parent.style.display = 'block';
      parent.style.position = 'absolute';
      parent.style.visibility = 'hidden';
      parent.style.left = '-9999px';
    }

    clamp.classList.add('is-measuring');
    var fullHeight = inner.scrollHeight;
    clamp.classList.remove('is-measuring');

    if (parentWasHidden && parent) {
      parent.style.display = saved.display;
      parent.style.position = saved.position;
      parent.style.visibility = saved.visibility;
      parent.style.left = '';
    }

    var maxHeight = getClampMax(clamp);
    clamp.classList.toggle('is-clamp-short', fullHeight <= maxHeight + 8);
  }

  function bindClamp(clamp) {
    if (clamp.dataset.tabClampBound === 'true') return;
    clamp.dataset.tabClampBound = 'true';

    var toggle = clamp.querySelector('.pango-tab-clamp__toggle');
    if (!toggle) return;

    var labelMore = toggle.dataset.labelMore || 'Leer más';
    var labelLess = toggle.dataset.labelLess || 'Ver menos';

    measureClamp(clamp);

    toggle.addEventListener('click', function () {
      var expanded = clamp.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.textContent = expanded ? labelLess : labelMore;
      if (!expanded) measureClamp(clamp);
    });
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-tab-clamp]').forEach(bindClamp);
    scope.querySelectorAll('.pango-tabs details').forEach(function (details) {
      if (details.dataset.tabClampAccordionBound === 'true') return;
      details.dataset.tabClampAccordionBound = 'true';
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        details.querySelectorAll('[data-tab-clamp]').forEach(measureClamp);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-tab-clamp]:not(.is-expanded)').forEach(measureClamp);
  });

  window.pangoMeasureTabClamp = measureClamp;
})();

/*========================================================================================================================================================
  #                                                                 XXX
==========================================================================================================================================================*/